import type { IEntityModel } from './base'
import type { IQuestionnaireDisplayRuleConditionInputNumber } from './questionnaire_display_rule_condition_input_number'
import type { IQuestionnaireDisplayRuleConditionInputOption } from './questionnaire_display_rule_condition_input_option'

export enum IQuestionnaireDisplayRuleConditionOperator {
  And = 'and',
  Or = 'or',
}

export enum IQuestionnaireDisplayRuleConditionType {
  Number = 'number',
  Option = 'option',
}

export interface IQuestionnaireDisplayRuleCondition extends IEntityModel {
  displayRuleId: string
  type: IQuestionnaireDisplayRuleConditionType
  inputNumberList?: IQuestionnaireDisplayRuleConditionInputNumber[]
  inputOptionList?: IQuestionnaireDisplayRuleConditionInputOption[]
  operator: IQuestionnaireDisplayRuleConditionOperator
}

export interface IQuestionnaireDisplayRuleConditionNumber
  extends IQuestionnaireDisplayRuleCondition {
  type: IQuestionnaireDisplayRuleConditionType.Number
  inputNumberList: IQuestionnaireDisplayRuleConditionInputNumber[]
}

export interface IQuestionnaireDisplayRuleConditionOption
  extends IQuestionnaireDisplayRuleCondition {
  type: IQuestionnaireDisplayRuleConditionType.Option
  inputOptionList: IQuestionnaireDisplayRuleConditionInputOption[]
}
